import { render, staticRenderFns } from "./FishIcon.vue?vue&type=template&id=3453e96c&scoped=true&"
import script from "./FishIcon.vue?vue&type=script&lang=js&"
export * from "./FishIcon.vue?vue&type=script&lang=js&"
import style0 from "./FishIcon.vue?vue&type=style&index=0&id=3453e96c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3453e96c",
  null
  
)

export default component.exports